/**
 * @ComponentFor CategoryViewModel
 */
import React, { useState } from 'react';
import { styled } from '@glitz/react';
import { scrollTo } from '@polarnopyret/scope';
import { PageType } from 'Shared/State';
import ProductListing from 'Product/ProductListing';
import CategoryType from './CategoryViewModel.type';
import Page, { Appearance as PageAppearance } from 'Shared/Page';
import Viewport from 'Shared/Viewport';
import Categories from './Categories';
import { ContentArea, EpiProperty, epiPropertyValue } from '@polarnopyret/scope-episerver';
import { Play12x12 } from 'Shared/Icons/Play';
import ProductListViewModel from 'Product/ProductListing/ProductListViewModel.type';
import { TopContentWide } from 'Shared/Page/PageContent';
import { SeoContent } from 'Shared/Page/PageBottom';
import EmbeddedContentModal from 'Cms/EmbeddedContentModal';

type PropType = CategoryType & PageType;

const PlayIcon = styled(Play12x12, {
  marginLeft: '8px'
})

export default (notProps: PropType) => {
  const [filterResults, setFilterResults] = useState<ProductListViewModel | undefined>(undefined);
  const [modalIsShown, setModalIsShown] = useState<boolean>(false);
  const props: PropType = { ...notProps, productList: filterResults ?? notProps.productList };
  
  const seoContentRef = React.createRef<HTMLDivElement>()
  
  return (
    <Viewport>
      {(isCompact: boolean) => {
        const modalButtonText = props.ageGroupModalContent?.buttonText ? props.ageGroupModalContent?.buttonText : null;
        
        return (
          <Page>
            <TopContentWide
              isCompact={isCompact}
              label={props.ageGroupContent?.label}
              heading={epiPropertyValue(props.page.heading)}
              intro={props.ageGroupContent?.mainIntro}
              modalButtonClick={() => setModalIsShown(true)}
              modalButtonText={modalButtonText}
              modalButtonIconAfter={
                props.video?.videoSources &&
                props.video?.videoSources.length > 0 && <PlayIcon />
              }
              breadcrumbs={props.breadcrumbs}
              readMoreLabel={props.labels.readMore}
              handleReadMore={(props.ageGroupContent?.mainIntro && props.ageGroupContent?.bottomText) ? () => { 
                  const elmTop = seoContentRef.current.offsetTop
                  scrollTo(elmTop - 100, 500);
              } : false}
            >
              <Categories categories={props.categoryTree.categories} isCompact={isCompact} />
            </TopContentWide>
            
            <EmbeddedContentModal
              modalIsShown={modalIsShown}
              hideModal={() => setModalIsShown(false)}
              labels={{
                textAboveHeading: props.ageGroupModalContent?.label,
                heading: props.ageGroupModalContent?.heading,
                close: props.labels.close,
              }}
              mainContentLabel={props.labels.guide}
              mainContent={<ContentArea items={props.ageGroupModalContent?.contentArea?.items} />}
              videoLabel={props.labels.video}
              video={props.video}
              videoProductsLabel={props.labels.productsInVideo}
              moreArticlesLabel={props.labels.moreGuides}
              moreArticles={props.articles}
              isCompact={isCompact}
            />
            <ProductListing {...props} content={null} setFilterResults={setFilterResults} />
            <EpiProperty for={props.page.bottomContentArea} />
            <div ref={seoContentRef}>
              <SeoContent
                heading={props.ageGroupContent?.bottomHeading}
                text={props.ageGroupContent?.bottomText}
              />
            </div>
          </Page>
        );
      }}
    </Viewport>
  );
};
